import AppBar from '@material-ui/core/AppBar';
import Container from '@material-ui/core/Container';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import NotFound from '@tracker/shared/src/NotFound';
import PreferencesProvider from '@tracker/shared/src/Preferences/PreferencesProvider';
import UserMenu from '@tracker/shared/src/UserMenu/UserMenu';
import React, {useState} from 'react';
import {Route, Switch} from 'react-router';
import {BrowserRouter} from 'react-router-dom';
import PreferencesDialog from './components/Preferences/PreferencesDialog';
import MyProjectsProvider from "./components/Tasks/MyProjectsProvider";
import RecentlyUsedTasksProvider from './components/Tasks/RecentlyUsedTasksProvider';
import TimeEntries from './pages/TimeEntries';
import {MissingTimeProvider} from "./Providers/MissingTimeProvider";
import {UnsubmittedContextProvider} from "./Providers/UnsubmittedProvider";

const useStyles = makeStyles(theme => ({
    title: {
        flexGrow: 1,
    },
    content: {
        padding: theme.spacing(4),
    },
}));

const Main : React.FC = () => {
    const classes = useStyles();
    const [preferencesOpen, setPreferencesOpen] = useState(false);

    return (
        <PreferencesProvider categories={['locale', 'timeEntry', 'dashboard']}>
            <MissingTimeProvider>
                <RecentlyUsedTasksProvider>
                    <MyProjectsProvider>
                        <AppBar position="static">
                            <Toolbar>
                                <Typography variant="h6" className={classes.title}>
                                    Time Entry
                                </Typography>
                                <UserMenu menuItems={[
                                    {title: 'Preferences', callback: () => setPreferencesOpen(true)},
                                ]}/>
                            </Toolbar>
                        </AppBar>


                        <Container maxWidth="lg" className={classes.content}>
                            <UnsubmittedContextProvider>
                                <BrowserRouter>
                                    <Switch>
                                        <Route path="/" exact component={TimeEntries}/>
                                        <Route path="*" component={NotFound}/>
                                    </Switch>
                                </BrowserRouter>
                            </UnsubmittedContextProvider>
                        </Container>


                        <PreferencesDialog
                            open={preferencesOpen}
                            onClose={() => setPreferencesOpen(false)}
                        />
                    </MyProjectsProvider>
                </RecentlyUsedTasksProvider>
            </MissingTimeProvider>
        </PreferencesProvider>
    );
};

export default Main;
